var _metadata, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    enableBackground: "new 0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, " Svg Vector Icons : http://www.onlinewebfonts.com/icon ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M93.2,127.6h16.6v27.2c0,5,4.1,9.1,9.1,9.1h18.2c5,0,9.1-4.1,9.1-9.1v-27.2h16.5c5.9,0,7-1,2-6.1l-27.5-27.5c-9.2-9.2-9.1-9.2-18.4,0l-27.5,27.5C86.2,126.7,87.9,127.6,93.2,127.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M218.8,50.8H109.8c0-15-12.2-27.2-27.2-27.2H37.2c-15,0-27.2,12.2-27.2,27.2v27.2v9.1v118c0,15,12.2,27.2,27.2,27.2h181.5c15,0,27.2-12.2,27.2-27.2V78.1C246,63.1,233.8,50.8,218.8,50.8z M227.8,205.2c0,5-4.1,9.1-9.1,9.1H37.2c-5,0-9.1-4.1-9.1-9.1V78.1c0-5,4.1-9.1,9.1-9.1h181.5c5,0,9.1,4.1,9.1,9.1V205.2L227.8,205.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M164.3,168.8c0,5-4.1,9.1-9.1,9.1h-54.5c-5,0-9.1-4.1-9.1-9.1v-9.1H73.5v9.1c0,15,12.2,27.2,27.2,27.2h54.5c15,0,27.2-12.2,27.2-27.2v-9.1h-18.2V168.8L164.3,168.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/Upload.d3a3e5e68aae855b012786dd9b411792.svg";
export { ForwardRef as ReactComponent };